import React, { useEffect } from "react";
import { useFormattedInput } from "../../hooks/useFormattedInput";

// Una línea de producto dentro del modal de venta: descripción,
// cantidad y precio unitario. Cantidad y precio se muestran con
// separador de miles y avisan al padre cuando cambia el valor limpio.
const ItemInput = React.memo(({ descripcion, cantidad, precio, index, handleItemChange }) => {
  const [cantidadValor, cantidadMostrada, alCambiarCantidad] = useFormattedInput(cantidad);
  const [precioValor, precioMostrado, alCambiarPrecio] = useFormattedInput(precio, true);

  useEffect(() => {
    if (String(cantidad) !== String(cantidadValor)) {
      handleItemChange(index, "cantidad", cantidadValor);
    }
  }, [cantidadValor, index, handleItemChange, cantidad]);

  useEffect(() => {
    if (String(precio) !== String(precioValor)) {
      handleItemChange(index, "precio", precioValor);
    }
  }, [precioValor, index, handleItemChange, precio]);

  return (
    <>
      <input
        type="text"
        placeholder="Descripción del Producto"
        value={descripcion}
        onChange={(e) => handleItemChange(index, "descripcion", e.target.value)}
        required
        className="input-descripcion"
      />
      <input
        type="text"
        placeholder="Cant."
        value={cantidadMostrada}
        onChange={alCambiarCantidad}
        required
        className="input-cantidad"
        inputMode="numeric"
      />
      <input
        type="text"
        placeholder="Precio Unitario"
        value={precioMostrado}
        onChange={alCambiarPrecio}
        required
        className="input-precio"
        inputMode="decimal"
      />
    </>
  );
});

export default ItemInput;
